import { Modal } from "antd";
import styled from "styled-components";

export const ModalInner = styled.div`
  .modal-share-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 16px;
    color: #1f1f1f;
  }

  .modal-share-bullets {
    margin: 0 0 20px;
    padding: 0;
    list-style: none;
    font-size: 14px;
    line-height: 1.65;
    color: #333;

    li {
      margin-bottom: 6px;
    }
  }

  .modal-share-checkboxes {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 12px 14px;
    height: min(40vh, 280px);
    overflow-y: auto;
    background: #fafafa;
  }

  .modal-share-row {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .modal-share-row--indent {
    padding-left: 20px;
  }

  .modal-share-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 24px;
    padding-top: 8px;
  }
`;

export const WrapModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }
`;
